import LocationPartnerForm from "./LocationPartnerForm";
import PrivateBookingForm from "./PrivateBookingForm";

const PARTNER_IMG =
  "https://images.pexels.com/photos/27990876/pexels-photo-27990876.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";
const EVENT_IMG =
  "https://images.unsplash.com/photo-1513151233558-d860c5398176?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njd8MHwxfHNlYXJjaHwyfHxwYXJ0eSUyMGV2ZW50JTIwY2VsZWJyYXRpb258ZW58MHx8fHwxNzgzODM5OTU1fDA&ixlib=rb-4.1.0&q=85";

export default function DualCTA() {
  return (
    <section className="relative py-16 md:py-24">
      <div className="mx-auto max-w-[1400px] px-6 md:px-10">
        <div className="flex items-end justify-between mb-14 flex-col md:flex-row gap-6">
          <div>
            <div className="font-mono-accent text-[11px] text-[#8B5CF6] mb-4">
              Two ways to Frostico
            </div>
            <h2 className="font-display text-5xl md:text-7xl font-bold tracking-tighter leading-[0.95]">
              Host it. <span className="italic text-white/70">Or hire it.</span>
            </h2>
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          {/* B2B */}
          <div
            id="partner"
            data-testid="partner-block"
            className="group relative rounded-3xl overflow-hidden border border-white/10 bg-[#15161C] p-8 md:p-10 transition-colors duration-300 hover:border-[#5AB0FF]/40"
          >
            <div className="relative aspect-[16/9] rounded-2xl overflow-hidden border border-white/10 mb-8">
              <img
                src={PARTNER_IMG}
                alt="Modern cafe partner location"
                className="absolute inset-0 h-full w-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#0A0B10]/95 via-[#0A0B10]/40 to-transparent" />
              <div className="absolute bottom-5 left-5 right-5 flex items-end justify-between">
                <div>
                  <div className="font-mono-accent text-[10px] text-[#5AB0FF]">
                    For Locations · B2B
                  </div>
                  <div className="font-display text-3xl md:text-4xl font-bold tracking-tight">
                    Host a Machine
                  </div>
                </div>
                <div className="rounded-full bg-[#5AB0FF] text-[#0A0B10] px-4 py-2 text-xs font-bold neon-glow-cyan">
                  15% Share
                </div>
              </div>
            </div>
            <p className="text-white/60 mb-8 max-w-lg leading-relaxed">
              Café, gym, office, student hall, cinema, hotel — request a
              Frostico machine at your location. We install, service and
              restock. You keep 15% of every sale.
            </p>
            <LocationPartnerForm />
          </div>

          {/* B2C */}
          <div
            id="book"
            data-testid="book-block"
            className="group relative rounded-3xl overflow-hidden border border-white/10 bg-[#15161C] p-8 md:p-10 transition-colors duration-300 hover:border-[#8B5CF6]/40"
          >
            <div className="relative aspect-[16/9] rounded-2xl overflow-hidden border border-white/10 mb-8">
              <img
                src={EVENT_IMG}
                alt="Party event confetti"
                className="absolute inset-0 h-full w-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#0A0B10]/95 via-[#0A0B10]/40 to-transparent" />
              <div className="absolute bottom-5 left-5 right-5 flex items-end justify-between">
                <div>
                  <div className="font-mono-accent text-[10px] text-[#8B5CF6]">
                    For Events · B2C
                  </div>
                  <div className="font-display text-3xl md:text-4xl font-bold tracking-tight">
                    Book for Event
                  </div>
                </div>
                <div className="rounded-full bg-[#8B5CF6] text-white px-4 py-2 text-xs font-bold neon-glow-pink">
                  Private Hire
                </div>
              </div>
            </div>
            <p className="text-white/60 mb-8 max-w-lg leading-relaxed">
              Weddings, birthdays, corporate away-days, brand activations. The
              Frostico rolls up to your venue and serves proper cups of
              soft-serve to your
              guests all night.
            </p>
            <PrivateBookingForm />
          </div>
        </div>
      </div>
    </section>
  );
}
